var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.lazy)?_c('img',_vm._b({attrs:{"data-src":_vm.cacheBustSrc,"alt":"","crossorigin":"anonymous"}},'img',_vm.$attrs,false)):_c('img',_vm._b({attrs:{"src":_vm.cacheBustSrc,"alt":"","loading":"lazy"}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }